import React from 'react';
import {Pagination as MuiPagination, PaginationItem} from '@mui/material';
import type {PaginationProps as MuiPaginationProps} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';

export interface PaginationProps extends MuiPaginationProps {
  testID?: string;
  handleOnChange: (nextPage: number) => void;
}

function Pagination({
  testID = 'pagination',
  handleOnChange,
  size = 'small',
  ...paginationProps
}: PaginationProps) {
  return (
    <MuiPagination
      data-testid={testID}
      onChange={(_, value) => handleOnChange(value)}
      size={size}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          sx={{
            '&.Mui-selected': {
              bgcolor: designSystemToken('semantic.bg.tertiary'),
            },
          }}
        />
      )}
      sx={{
        '& .MuiPaginationItem-root': {
          color: designSystemToken('semantic.fg.primary'),
        },
      }}
      {...paginationProps}
    />
  );
}

export default Pagination;
